import { useCallback, useEffect, useReducer, useState } from 'react';
import { GetInfo } from '@allie/mfe';
import { env } from '@env';
import { config, isSmartTV } from '../helpers';

const EFFICIENCY_BASE_PATH = env.REACT_APP_EFFICIENCY_ENTRYPOINT.replace('/remoteEntry.js', '');
const CONFIG_BASE_PATH = env.REACT_APP_CONFIGURATIONS_ENTRYPOINT.replace('/remoteEntry.js', '');
const FGPT_BASE_PATH = env.REACT_APP_FACTORY_GPT_ENTRYPOINT.replace('/remoteEntry.js', '');

const MFES_TO_CHECK = [
  { name: 'efficiency', getInfo: () => GetInfo(EFFICIENCY_BASE_PATH) },
  { name: 'configurations', getInfo: () => GetInfo(CONFIG_BASE_PATH) },
  { name: 'factory-gpt', getInfo: () => GetInfo(FGPT_BASE_PATH) }
];

type versions = Record<string, string>;

export const useAllieVersionWatcher = () => {
  const [intervalRef, setIntervalRef] = useState<NodeJS.Timeout>();
  const [versions, setVersions] = useReducer((prevState: versions, value: versions) => {
    return { ...prevState, ...value };
  }, {});

  const checkVersions = useCallback(async () => {
    const newVersions: versions = {};
    for (const mfe of MFES_TO_CHECK) {
      try {
        const { getInfo } = await mfe.getInfo();
        const newVersion = getInfo().version;

        // If version changes && isTV && the app it's in the outdated mfe
        if (
          versions[mfe.name] &&
          versions[mfe.name] !== newVersion &&
          isSmartTV &&
          window.location.pathname.includes(mfe.name)
        ) {
          window.location.reload();
        }
        if (versions[mfe.name] !== newVersion) {
          newVersions[mfe.name] = getInfo().version;
        }
      } catch {
        continue;
      }
    }

    if (Object.keys(newVersions)) {
      setVersions(newVersions);
    }
  }, [versions]);

  useEffect(() => {
    intervalRef && clearInterval(intervalRef);
    setIntervalRef(setInterval(checkVersions, config.VERSION_CHECK_INTERVAL));

    return () => intervalRef && clearInterval(intervalRef);
  }, [checkVersions]);

  return { versions };
};
